import { IPublishRulesTreeItem } from '../interfaces/IPublishRulesTreeItem';

export function markTreeWithSavedSettings(
  tree: IPublishRulesTreeItem[],
  savedCategories: string[],
): IPublishRulesTreeItem[] {
  return tree.map(node => {
    const hasSaved = savedCategories?.includes(node.category);

    const children = node?.children ? markTreeWithSavedSettings(node.children, savedCategories) : undefined;

    return {
      ...node,
      haveSavedSettings: hasSaved,
      ...(children ? { children } : {}),
    };
  });
}
